import React from 'react';
import { motion } from 'framer-motion';

const Footer = ({ currentPage, setCurrentPage }) => {
  return (
    <motion.footer 
      className="app-footer"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 1 }}
    >
      <div className="footer-content">
        <div className="footer-links">
          <span 
            className="footer-link"
            onClick={() => setCurrentPage('privacy')}
          >
            Privacy Policy
          </span>
          <span 
            className="footer-link"
            onClick={() => setCurrentPage('terms')}
          >
            Terms of Service
          </span>
          <a href="https://discord.gg/3MkNgDRt8B" target="_blank" rel="noopener noreferrer" className="footer-link">
            Join our Discord
          </a>
        </div>
        <div className="footer-copyright">
          © 2025 BrainRotAI. All rights reserved.
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;
